import React, {Component} from 'react';
import axios from '../axios';

class opinions extends Component{

    state = {
        message: null,
        name: null,
        email: null,
        buttonText: "Enviar"
    };

    onMessageChangeHandler = (e) => {
        this.setState({
            message: e.target.value
        })
    };

    onNameChangeHandler = (e) =>{
        this.setState({
            name: e.target.value
        })
    };

    onEmailChangeHandler = (e) => {
        this.setState({
            email: e.target.value
        })
    };

    resetForm = () => {
        this.setState({
            name: '',
            message: '',
            email: '',
            buttonText: 'Mensagem Enviada'
        })
    };

    formSubmit = (e) => {
        e.preventDefault();

        this.setState({
            buttonText: '...A enviar'
        });

        let data = {
            name: this.state.name,
            email: this.state.email,
            message: this.state.message
        };

        axios.post('user/suggestions', data)
            .then( res => {
                this.setState({
                    sent: true },
                    this.resetForm)
            })
            .catch( () => {
                console.log('Mensagem não enviada')
            })
    };

    render(){
        return(
            <div className="container col-12 mt-6 mr-0 ml-0 form-group shadow-textarea">
                <form className="contact-form" onSubmit={(e) => this.formSubmit(e)}>
                    <div className="row col-12 mt-6">
                        <label className="message-name col-2" htmlFor="message-name">Nome:</label>
                        <input onChange={this.onNameChangeHandler} name="name" cols="40" className="message-name"
                               type="text" placeholder="Nome" value={this.state.name}/>
                    </div>
                    <div className="row col-12 mt-2">
                        <label className="message-email col-2" htmlFor="message-email">Email:</label>
                        <input onChange={this.onEmailChangeHandler} name="email" cols="40" className="message-email"
                               type="email" placeholder="exemplo@email.com" required value={this.state.email}/>
                    </div>
                    <div className="row col-12 mt-2">
                        <label className="message col-2" htmlFor="message-input">A sua mensagem:</label>
                        <textarea onChange={this.onMessageChangeHandler} name="Mensagem"
                                  className="message-input" type="text" rows="10" cols="100" placeholder="Escreva a sua mensagem aqui"
                                  value={this.state.message} required/>
                    </div>
                    <div className="row col-12 mt-3 button--container">
                        <button type="submit" className="button button-primary">{this.state.buttonText}</button>
                    </div>
                </form>
            </div>
        )
    }
}

export default opinions;



// WEBPACK FOOTER //
// ./src/containers/opinions.js